import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { getMeCached } from '../authCache';
import ForestTeacherView from './ForestTeacherView.jsx';

const ForestPage = () => {
  const navigate = useNavigate();
  const [schoolId, setSchoolId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const me = await getMeCached();
        if (cancelled) return;

        const sid = String(me?.data?.admin_user?.school_id || '').trim();
        if (!me?.ok || !sid) {
          setError('Okul bilgisi bulunamadı.');
          return;
        }
        setSchoolId(sid);
      } catch (e) {
        if (cancelled) return;
        setError('Oturum bilgisi alınamadı.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <Box sx={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {!!error && <Alert severity="error">{error}</Alert>}
      {!error && !!schoolId && (
        <ForestTeacherView
          schoolId={schoolId}
          onError={setError}
          onBack={() => navigate('/admin')}
        />
      )}
    </>
  );
};

export default ForestPage;
